import { startOfDay, subDays } from "date-fns";
import { RangePreset } from "../../newcomponents/datepicker";
import { Audit } from "./types";

export function getAuditSubject(
  audit: Audit,
): { value: string; type: "user" | "serviceaccount" | "other"; link?: string } {
  if (!audit.subject) {
    return { value: "", type: "other" };
  }
  try {
    if (audit.subject.name || audit.subject.data?.principalLink) {
      let name = "";
      if (audit.subject.data?.principalLink) {
        name = audit.subject.data.principalLink.split("/")[4];
      } else if (audit.subject.name) {
        name = audit.subject.name;
      }
      let isServiceAccount = audit.subject.data?.type === "serviceaccount";
      if (isServiceAccount) {
        return { value: name, type: "serviceaccount", link: audit.subject.data?.principalLink };
      }
      let isUser = audit.subject.data?.type === "user";
      if (isUser) {
        return { value: name, type: "user", link: audit.subject.data.principalLink };
      }
      return { value: name, type: "other" };
    }
    return { value: audit.subject.email || "", type: "other" };
  } catch (e) {
    return { value: audit.subject.name || audit.subject.email || "", type: "other" };
  }
}

export function getLogsPresetsNew(): RangePreset[] {
  return [
    { label: "Last 5 Minutes", value: ["now-5m", ""] },
    { label: "Last 15 Minutes", value: ["now-15m", ""] },
    { label: "Last 30 Minutes", value: ["now-30m", ""] },
    { label: "Last 1 Hour", value: ["now-1h", ""] },
    { label: "Last 3 Hours", value: ["now-3h", ""] },
    { label: "Last 6 Hours", value: ["now-6h", ""] },
    { label: "Last 12 Hours", value: ["now-12h", ""] },
    { label: "Last 24 Hours", value: ["now-1d", ""] },
    { label: "Last 2 Days", value: ["now-2d", ""] },
    { label: "Last 7 Days", value: ["now-7d", ""] },
    { label: "Last 30 Days", value: ["now-30d", ""] },
  ];
}

export interface LogsPresetForGrafana {
  label: string;
  presetValue: string;
  minuteDiff: number;
  hourDiff: number;
  dayDiff: number;
}

export function getLogsPresetsForGrafana(): LogsPresetForGrafana[] {
  return [
    { label: "Last 5 Minutes", presetValue: "5m", minuteDiff: 5, hourDiff: 0, dayDiff: 0 },
    { label: "Last 15 Minutes", presetValue: "15m", minuteDiff: 15, hourDiff: 0, dayDiff: 0 },
    { label: "Last 30 Minutes", presetValue: "30m", minuteDiff: 30, hourDiff: 0, dayDiff: 0 },
    { label: "Last 1 Hour", presetValue: "1h", minuteDiff: 60, hourDiff: 1, dayDiff: 0 },
    { label: "Last 3 Hours", presetValue: "3h", minuteDiff: 180, hourDiff: 3, dayDiff: 0 },
    { label: "Last 6 Hours", presetValue: "6h", minuteDiff: 360, hourDiff: 6, dayDiff: 0 },
    { label: "Last 12 Hours", presetValue: "12h", minuteDiff: 720, hourDiff: 12, dayDiff: 0 },
    { label: "Last 24 Hours", presetValue: "24h", minuteDiff: 1440, hourDiff: 24, dayDiff: 1 },
    { label: "Last 2 Days", presetValue: "2d", minuteDiff: 2880, hourDiff: 48, dayDiff: 2 },
    { label: "Last 7 Days", presetValue: "7d", minuteDiff: 10080, hourDiff: 168, dayDiff: 7 },
    { label: "Last 30 Days", presetValue: "30d", minuteDiff: 43200, hourDiff: 720, dayDiff: 30 },
  ];
}

export function getAuditTrailPresetsNew(): RangePreset[] {
  return [
    { label: "Last 1 Hour", value: ["now-1h", ""] },
    { label: "Last 1 Day", value: ["now-1d", ""] },
    { label: "Last 1 Week", value: ["now-7d", ""] },
    { label: "Last 2 Weeks", value: ["now-14d", ""] },
    { label: "Last 30 Days", value: ["now-30d", ""] },
    { label: "Last 3 Months", value: ["now-3M", ""] },
  ];
}

export function getDefaultAuditTrailTimeNew(): string {
  const now = new Date();
  return subDays(startOfDay(now), 6).toISOString();
}

export function resolveSubjectName(subjectInput: string, org: string): string {
  if (subjectInput.includes("@") || subjectInput.startsWith("/")) {
    return subjectInput;
  }
  return `/org/${org}/serviceaccount/${subjectInput}`;
}
